const activity = {
  activity: "Activité", // translated
  activities: "Activités", // translated
  dates: "Rendez-vous", // translated
  location: "Emplacement", // translated
  languages: "Langues", // translated
  categories: "Catégories", // translated
  ticketOption: "Option billet", // translated
  numberOfRatings: "Nombre de notes", // translated
  meetingPointInfo: "Informations sur le point de rendez-vous", // translated
  meetingPoint: "Point de rencontre", // translated
  meetingPoints: "Points de rendez-vous", // translated
  providedBy: "Fourni par", // translated
  expirationDate: "Date d'expiration", // translated
  groupSize: "Taille de groupe", // translated
  features: "Caractéristiques", // translated
  basedOn: "Basé sur", // translated
  reviewsFromVerCustomers: "avis de clients vérifiés", // translated
  excellent: "excellent", // translated
  great: "super", // translated
  average: "moyenne", // translated
  poor: "pauvre", // translated
  bad: "mauvais", // translated
  onlyBookedCustomersTooltip: "Seuls les clients ayant réservé cette activité peuvent laisser un avis", // translated
  noReviewsYet: "Pour le moment, il n'y a aucun avis sur cette activité.", // translated
  backToActivitiesList: "Retour à la liste des activités", // translated
  getPrices: "obtenir des prix", // translated
  availabilityAndPrices: "Disponibilité et prix", // translated
  ticketOptions: "Options de billets", // translated
  ticketInfo: "Informations sur les billets", // translated
  selectYourTickets: "Sélectionnez vos billets", // translated
  product: "Produit", // translated
  total: "Total", // translated
  slot: "Fente", // translated
  language: "Langue", // translated
  tickets: "Des billets", // translated
  ticketsFor: "Billets pour", // translated
  previousStep: "Étape précédente", // translated
  onlyAvailableInEnglish: "Uniquement disponible en anglais", // translated
  guest: "Invité", // translated
  leadGuest: "Invité principal", // translated
  adult: "Adulte", // translated
  child: "Enfant", // translated
  pleaseSelectAdult: "Veuillez sélectionner au moins un adulte", // translated
  notAvailableActivity: "Ce produit n'est pas disponible", // translated
  required: "Requis", // translated
  pickupPoint: "Point de retrait", // translated
  pickupPoints: "Points de retrait", // translated
  ticketType: "Type de billet", // translated
  anonymous: "Anonyme", // translated
  printedVoucher: "Bon imprimé accepté", // translated
  mobileVoucher: "Bon mobile accepté", // translated
  mixedVoucher: "Bon mobile ou imprimé accepté", // translated
  safetyMeasures: "Mesures de sécurité appliquées", // translated
  doThisBecause: "Faites ceci parce que", // translated
  safetyInfo: "Informations de sécurité", // translated
  reviewsHighestFirst: "Nombre d'avis (le plus élevé en premier)", // translated
  bookingFee: "Frais de réservation", // translated
  startDate: "Date de début", // translated
  endDate: "Date de fin", // translated
  cancellationDeadlineAndFees: "Délai et frais d’annulation", // translated
  resetTickets: "Réinitialiser les billets", // translated
  instantConfirmation: "Confirmation instantanée", // translated
  clickResetBtn: "Cliquez sur le bouton réinitialiser pour recommencer votre sélection", // translated
};

export default activity;
